"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rules = [
    {
        tense: ["present", "simple"],
        rootTense: "present",
        auxNo: 0,
        auxBases: [],
        auxTenses: [],
    },
    {
        tense: ["present", "simple"],
        rootTense: "present",
        auxNo: 1,
        auxBases: ["do"],
        auxTenses: ["present"],
    },
    {
        tense: ["past", "simple"],
        rootTense: "past",
        auxNo: 0,
        auxBases: [],
        auxTenses: [],
    },
    {
        tense: ["past", "simple"],
        rootTense: "present",
        auxNo: 1,
        auxBases: ["do"],
        auxTenses: ["past"],
    },
    {
        tense: ["present", "progressive"],
        rootTense: "gerund",
        auxNo: 1,
        auxBases: ["be"],
        auxTenses: ["present"],
    },
    {
        tense: ["past", "progressive"],
        rootTense: "gerund",
        auxNo: 1,
        auxBases: ["be"],
        auxTenses: ["past"],
    },
    {
        tense: ["present", "perfect", "simple"],
        rootTense: "past",
        auxNo: 1,
        auxBases: ["have"],
        auxTenses: ["present"],
    },
    {
        tense: ["present", "perfect", "progressive"],
        rootTense: "gerund",
        auxNo: 2,
        auxBases: ["have", "be"],
        auxTenses: ["present", "past"],
    },
    {
        tense: ["past", "perfect", "simple"],
        rootTense: "past",
        auxNo: 1,
        auxBases: ["have"],
        auxTenses: ["past"],
    },
    {
        tense: ["past", "perfect", "progressive"],
        rootTense: "gerund",
        auxNo: 2,
        auxBases: ["have", "be"],
        auxTenses: ["past", "past"],
    },
    {
        tense: ["future", "simple", "(going)"],
        rootTense: "present",
        auxNo: 3,
        auxBases: ["be", "go", "to"],
        auxTenses: ["present", "gerund", ""],
    },
    {
        tense: ["future", "simple"],
        rootTense: "present",
        auxNo: 1,
        auxBases: ["will"],
        auxTenses: ["present"],
    },
    {
        tense: ["future", "progressive"],
        rootTense: "gerund",
        auxNo: 2,
        auxBases: ["will", "be"],
        auxTenses: ["present", "present"],
    },
    {
        tense: ["future", "perfect", "simple"],
        rootTense: "past",
        auxNo: 2,
        auxBases: ["will", "have"],
        auxTenses: ["present", "present"],
    },
    {
        tense: ["future", "perfect", "progressive"],
        rootTense: "gerund",
        auxNo: 3,
        auxBases: ["will", "have", "be"],
        auxTenses: ["present", "present", "past"],
    }
];
